<template>
  <div
    v-editable="blok"
    class="inline-images prose z-10 mx-auto w-full dark:prose-invert"
    :class="[
      proseAlignment,
      proseJustification,
      { '!max-w-[unset]': blok.fullWidth },
      blok.size === 'lg' ? 'prose-xl' : blok.size === 'sm' ? 'prose-base leading-snug' : 'prose-lg',
    ]"
    v-html="renderedText"
  />
</template>

<script setup lang="ts">
import type { TextStoryblok } from "~/storyblok-component-types"

const props = defineProps<{ blok: TextStoryblok; }>()

const renderedText = renderRTF(props.blok?.text)
const proseAlignment = computed(() => {
  switch (props.blok.alignment) {
    case "start":
      return "text-start"
    case "center":
      return "text-center"
    case "end":
      return "text-end"
    case "block":
      return "text-justify hyphens-auto prose-headings:hyphens-none"
    default:
      return "text-left"
  }
})
const proseJustification = computed(() => {
  switch (props.blok.justification) {
    case "top":
      return "self-top"
    case "center":
      return "self-center"
    case "bottom":
      return "self-bottom"
    default:
      return "self-bottom"
  }
})
</script>
